@if (isVisible && config) {
  <div class="alert-interceptor-container">
    <div class="overlay" [class.closing]="isClosing"></div>
    <div class="alert-interceptor-content" [class.closing]="isClosing">
      <div class="close" (click)="close()">
        <i class="icon icon-close"></i>
      </div>
      <div class="content-container">
        <img class="image" src="/assets/illustrations/{{ config.image }}" [alt]="config.title">
        <div class="text-container">
          <h2 class="title">{{ config.title }}</h2>
          <p class="description">{{ config.description }}</p>
        </div>
        <app-button class="action-button" [innerId]="config.innerId" [label]="config.actionLabel" styleClass="primary expand" (action)="click()" />
      </div>
    </div>
  </div>
}